export enum TaskStatus {
  NEW = 'NEW',

  ACTIVE = 'ACTIVE',

  COMPLETED = 'COMPLETED',
}
